import React, { FC, ReactNode } from 'react';
import styles from './CvTemplate.module.less';
import { Button, Card, Space } from 'antd';

type Props = {
  onColorChange?: (value: string) => void;
  selectedColor?: string;
  onCancel?: (value: boolean) => void;
  selectedTemplateTitle: string;
  button?: ReactNode;
};
export const TEMPLATE_COLORS = ['#080808', '#042357', '#022715', '#333434', '#2e3070'];
export const TEMPLATE_LIGHT_COLORS = [
  '#14ae9f',
  '#468f9a',
  '#9dd9b8',
  '#38b8ba',
  '#006666',
  '#49308b',
];
export const darkTemaplateTitles = [
  'Template 1',
  'Template 8',
  'Template 10',
  'Template 11',
  'Template 12',
  'Template 13',
  'Template 14',
  'Template 15',
  'Template 16',
  'Template 17',
  'Template 18',
  'Template 19',
  'Template 20',
  'Template 21',
];

export const TemplateModalFooter: FC<Props> = (props) => {
  const { onColorChange, selectedColor, onCancel, button } = props;
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerContent}>
        <Space>
          {(darkTemaplateTitles.includes(props.selectedTemplateTitle)
            ? TEMPLATE_COLORS
            : TEMPLATE_LIGHT_COLORS
          ).map((color, index) => (
            <div
              key={index}
              className={selectedColor === color ? styles.selectedColorBox : undefined}>
              <Card
                onClick={() => {
                  onColorChange?.(color);
                }}
                style={{ backgroundColor: color }}
                className={styles.colorBox}
              />
            </div>
          ))}
        </Space>
      </div>
      <Space align={'end'}>
        <Button onClick={() => onCancel?.(false)}>Cancel</Button>
        {button && button}
      </Space>
    </div>
  );
};
